<template>
  <div class="funds-list page-box">
    <query-header ref="header" @toQuery="toQuery"></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table :noDataText="$t('root.noData')" :data="listData">
          <template slot="thead">
            <vs-th>
              {{ $t('Trade.orderNo') }}
            </vs-th>
            <vs-th>
              {{ $t('User.reportComiType') }}
            </vs-th>
            <vs-th>
              {{ $t('Billing_message') }}
            </vs-th>
            <vs-th>
              {{ $t('User.reportCommiAmount') }}
            </vs-th>
            <vs-th>
              {{ $t('Approval_Status') }}
            </vs-th>
            <vs-th>
              {{ $t('remark') }}
            </vs-th>
            <vs-th>
              {{ $t('root.time') }}
            </vs-th>
            <vs-th class="vstablethcenter">
              {{ $t('operate') }}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data">
              <vs-td>
                {{ tr.id }}
              </vs-td>

              <vs-td>
                {{ getType(tr) }}
              </vs-td>
              <vs-td>
                {{ getInfo(tr) }}
              </vs-td>
              <vs-td>
                {{ '$' + (tr.amount || 0) }}
              </vs-td>
              <vs-td>
                <span class="tag-box" :style="getStyle(tr)">{{ getStatus(tr) }}</span>
              </vs-td>
              <vs-td style="max-width: 230px;">
                <span v-if="tr.chkStatus == 7">
                  {{ tr.rejectReason || '-' }}
                </span>
              </vs-td>
              <vs-td>
                {{ tr.createTime }}
              </vs-td>
              <vs-td style="text-align: center;">

                <el-button
                class="pointer"
                size="large"
                v-if="tr.chkStatus && tr.chkStatus == 1"
                @click="activePrompt = true; currentId = tr.id;"
              >{{$t('cancel')}}</el-button>

         
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <!-- <vs-prompt :active.sync="activePrompt" class="customprompt" title="" :acceptText="$t('Confirm')" :cancelText="$t('cancel')"
        @accept="cancelCommissionHandle">

        <div class="con-exemple-prompt">
          <br>
          &nbsp;&nbsp;{{$t('User.confirmCancelCommission')}}?


        </div>
      </vs-prompt> -->
       <vs-popup class="custompopup"  title="" :active.sync="activePrompt">
         <div class="con-exemple-prompt">
          <br>
          &nbsp;&nbsp;{{$t('User.confirmCancelCommission')}}?
        </div>

        <footer>
          <vs-button class="cancleBtn" color="primary" type="flat" @click="activePrompt=false;">{{ $t('cancel') }}</vs-button>
          <vs-button color="primary" type="filled" @click="cancelCommissionHandle">{{ $t('Confirm') }}</vs-button>
        </footer>

      </vs-popup>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{ $t('total') }} {{ total }} {{ $t('item') }}</span>
        </div>
        <vs-pagination class="pagination-box" :max="max" :total="pageSize" v-model="page"></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime, getIsMoreThreeMonth,colorRgba } from '@/utils/index';
import { cancelCommission } from '@/api/user';
// 表格字段需要重新调
import { changeTimestamp } from '@/utils/common';
import commissionInitData from "./commissionInitData";
import queryHeader from "@/components/agent/commissionManage/commissionOutRecord/queryHeader";
export default {
  name: "index",
  components: {
    queryHeader,
  },
  data() {
    return {
      activePrompt: false,
      currentId: "",
      red: '#D85E5F',
      green: '#41B883',
    }
  },
  mixins: [commissionInitData],
  computed: {
    ...mapGetters(['userInfo','themeColor']),
  },
  mounted() {
    this.init();
  },
  methods: {
    parseTime,
    beforeInit() {
      this.url = '/crm/reception/partner/commWithdraw';

      this.params = {
        pageNum: this.page,
        pageSize: this.size,
        custId: this.userInfo.id,
      }
      let header = this.$refs.header;
      // 添加时间

      if (header.outType !== '') {
        this.params.type = header.outType;
      }
      if (header.status) {
        this.params.chkStatus = header.status;
      }
      if (header.date && header.date.length) {
        this.params.startTime = header.date[0];
        this.params.endTime = header.date[1];
      }
      return true;
    },

    getInfo(row) {
      switch (row.type) {
        case 0:
          return row.mt4Account;
        case 7:
          return row.bankAccount;
        case 8:
          return row.bankAccount;
        case 9:
          return row.bankAccount;
      }
    },
    getType(row) {
      switch (row.type) {
        case 0:
          return this.$t('User.reportComiType2');
        case 7:
          return this.$t('User.reportComiType1');
        case 8:
          return this.$t('The_commission_to_USDT');
        case 9:
          return this.$t('The_commission_to_OTC365');
      }
    },
    getStatus(item) {
      return item.chkStatus == 6 ? this.$t('User.reportCommiStatus1') : item.chkStatus == 7 ? this.$t('User.reportCommiStatus2') : this.$t('User.reportCommiStatus3')
    },
    getStyle(tr) {
      if (tr.chkStatus == 6) {
        return {
          backgroundColor: colorRgba(this.green, 0.1),
          color: this.green,
        };
      } else if (tr.chkStatus == 7) {
        return {
          backgroundColor: colorRgba(this.red, 0.1),
          color: this.red,
        };
      } else {
        return {
          backgroundColor: colorRgba(this.themeColor, 0.1),
          color: this.themeColor,
        };
      }
    },
    searchHandle() {
      this.page = 1;
      this.init();
    },
    cancelCommissionHandle(tr) {
      cancelCommission(this.currentId).then((res) => {
          if (res && res.status && res.status == 10000) {
            this.$message({
              type: 'success',
              message: this.$t('withgold.operatingSuccess')
            });
            this.searchHandle();
            this.activePrompt = false;
          } else {
            this.$message.error(res.msg);
          }
        })
    }

  },
}
</script>
<style lang="scss">
.custompopup{
  .vs-popup{
    width: 400px;
    height: 170px;
    footer{
      float: right;
      margin-top: 20px;
      .cancleBtn{
        margin-right: 10px;
      }
    }
  }
}
.vstablethcenter .vs-table-text{
    justify-content: center;
  }
</style>
<style lang="scss" scoped>
.search-input {
  &.symbol {
    margin-left: 10px;
  }
}
 .page-content .vs-table--tr .vs-table--td button.el-button:hover  span{
     color: #FE5924 !important;
  }
  .el-button {
    padding: 7px 10px;
    font-size: 12px;
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
</style>
